export const ASSET_LIBERARY_ACTIONS = {
  SET_STATE: "assetLiberary/setState",
  GET_ASSET_LIBERARY: "assetLiberary/getAssetLiberary",
  GET_ASSET_LIBERARY_BY_ID: "assetLiberary/getAssetLiberaryById",
  CREATE_ASSET_LIBERARY: "assetLiberary/createAssetLiberary",
  UPDATE_ASSET_LIBERARY: "assetLiberary/updateAssetLiberary",
  DELETE_ASSET_LIBERARY: "assetLiberary/deleteAssetLiberary",
};
